import React, {
  FC, useEffect, useState,
} from 'react';
import { FaChevronLeft } from 'react-icons/fa6';
import {
  Button,
} from './Styles';
import Header from '../../../../Common/Header';
import ComingSoonModal from '../../../../Common/ComingSoonModal';
import PlatformLayout from '../../../../Common/PlatformLayout';
import { Column } from '../../../../Common/Logo/Styles';

const SelectPlatform: FC<Props> = ({
  cabId32Str,
  setTargetPage,
  isEnglish,
  setIsEnglish,
  selectedPlatform,
  setSelectedPlatform,
  setShowLoading,
}) => {
  const [showComingSoonModal, setShowComingSoonModal] = useState<boolean>();

  useEffect(() => {
    setShowLoading(false);
  }, []);

  useEffect(() => {
    if (selectedPlatform != null) {
      // 其他平台使用房间号租用柜门
      if ([3, 4, 5, 6].includes(selectedPlatform)) {
        setTargetPage('room-num-reopen-box');
      }
      else {
        // 熊猫平台、饭团平台延用以前的逻辑
        setTargetPage('user-reopen-box');
      }
    }
  }, [selectedPlatform]);

  return (
    <>
      {
        showComingSoonModal && (
          <ComingSoonModal onClose={() => setShowComingSoonModal(false)} isEnglish={isEnglish} />
        )
      }
      {/* 头部 */}
      <Header
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        style={{ marginTop: '50px' }}
        setTargetPage={setTargetPage}
      />

      {/* 重新开柜标题 */}
      <Column style={{ marginTop: '20px' }}>
        <Button
          style={{ position: 'absolute', left: '15px', marginTop: '2px' }}
          onClick={() => setTargetPage('home')}
        >
          <FaChevronLeft style={{ fontSize: '20px', color: '#11202B' }} />
        </Button>
        {
          isEnglish ? (
            <div style={{ height: '30px', fontSize: '30px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '40px' }}>
              Reopen the locker
            </div>
          ) : (
            <div style={{ height: '42px', fontSize: '30px', fontFamily: 'PingFangSC-Semibold, PingFang SC', fontWeight: 600, color: '#11202B', lineHeight: '42px' }}>
              重新开柜
            </div>
          )
        }
      </Column>

      {/* 标题 */}
      {
        isEnglish ? (
          <div style={{ fontSize: '20px', fontFamily: 'Squad-Regular, Squad', fontWeight: 400, color: '#11202B', lineHeight: '21px', textAlign: 'center', marginTop: '18px', opacity: 0.6 }}>
            Select your platform
          </div>
        ) : (
          <div style={{ fontSize: '20px', fontFamily: 'PingFangSC-Regular, PingFang SC', fontWeight: 400, color: '#11202B', lineHeight: '21px', textAlign: 'center', marginTop: '18px', opacity: 0.6 }}>
            请选择您的点餐平台
          </div>
        )
      }

      {/* 商家列表 */}
      <PlatformLayout isEnglish={isEnglish} callback={setSelectedPlatform} />
    </>
  );
};

export interface Props {
  cabId32Str: string;
  setTargetPage: (targetPage: string) => void;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  selectedPlatform?: number;
  setSelectedPlatform: (platform?: number) => void;
  setShowLoading: (isShow: boolean) => void;
}

export default SelectPlatform;
